import request from '../../config/axiosConfig';
import * as api from '../../constants/apiEndPoint';

export const uploadImageToServer = async (file) => {
  const formData = new FormData();
  formData.append('file', file);
  const { data } = await request({
    url: api.UPLOAD_IMAGE,
    method: 'POST',
    data: formData,
  });
  if (data?.data?.url) return data.data.url;
  throw new Error(data?.message || 'Upload thất bại');
};

// Generic CRUD service factory for frontend
const createService = (endpoints) => ({
  getList: async (dataBody) => {
    const { data } = await request({ url: endpoints.getList, method: 'POST', data: dataBody });
    return data;
  },
  create: async (dataBody) => {
    const { data } = await request({ url: endpoints.create, method: 'POST', data: dataBody });
    return data;
  },
  update: async (id, dataBody) => {
    const { data } = await request({ url: endpoints.update, method: 'POST', data: { id, ...dataBody } });
    return data;
  },
  delete: async (id) => {
    const { data } = await request({ url: endpoints.delete, method: 'POST', data: { id } });
    return data;
  },
  ...(endpoints.listActive ? {
    listActive: async () => {
      const { data } = await request({ url: endpoints.listActive, method: 'POST' });
      return data?.data || data;
    },
  } : {}),
});

// ====== Service instances ======
export const contentCategoryService = createService({
  getList: api.GET_LIST_CONTENT_CATEGORIES, create: api.CREATE_CONTENT_CATEGORY,
  update: api.UPDATE_CONTENT_CATEGORY, delete: api.DELETE_CONTENT_CATEGORY,
  listActive: api.LIST_ACTIVE_CONTENT_CATEGORIES,
});

export const postService = createService({
  getList: api.GET_LIST_POSTS, create: api.CREATE_POST,
  update: api.UPDATE_POST, delete: api.DELETE_POST,
});

export const albumService = createService({
  getList: api.GET_LIST_ALBUMS, create: api.CREATE_ALBUM,
  update: api.UPDATE_ALBUM, delete: api.DELETE_ALBUM,
  listActive: api.LIST_ACTIVE_ALBUMS,
});

export const imageService = createService({
  getList: api.GET_LIST_IMAGES, create: api.CREATE_IMAGE,
  update: api.UPDATE_IMAGE, delete: api.DELETE_IMAGE,
});

export const contentVideoService = createService({
  getList: api.GET_LIST_CONTENT_VIDEOS, create: api.CREATE_CONTENT_VIDEO,
  update: api.UPDATE_CONTENT_VIDEO, delete: api.DELETE_CONTENT_VIDEO,
});

export const fileService = createService({
  getList: api.GET_LIST_FILES, create: api.CREATE_FILE,
  update: api.UPDATE_FILE, delete: api.DELETE_FILE,
});

export const idiomService = {
  ...createService({
    getList: api.GET_LIST_IDIOMS, create: api.CREATE_IDIOM,
    update: api.UPDATE_IDIOM, delete: api.DELETE_IDIOM,
  }),
  importExcel: async (file) => {
    const formData = new FormData();
    formData.append('file', file);
    const { data } = await request({
      url: api.IMPORT_IDIOMS,
      method: 'POST',
      data: formData,
      timeout: 60000, // import có thể lâu hơn, nới timeout mặc định
    });
    return data;
  },
};

export const heroscopService = createService({
  getList: api.GET_LIST_HEROSCOPS, create: api.CREATE_HEROSCOP,
  update: api.UPDATE_HEROSCOP, delete: api.DELETE_HEROSCOP,
});

export const horoscopService = {
  ...createService({
    getList: api.GET_LIST_HOROSCOPS, create: api.CREATE_HOROSCOP,
    update: api.UPDATE_HOROSCOP, delete: api.DELETE_HOROSCOP,
  }),
  // Lấy lại dữ liệu tử vi trong ngày từ API nguồn (gọi API ngoài nên nới timeout)
  resetData: async () => {
    const { data } = await request({ url: api.RESET_HOROSCOP_DATA, method: 'POST', timeout: 60000 });
    return data;
  },
};

export const cardService = createService({
  getList: api.GET_LIST_CARDS, create: api.CREATE_CARD,
  update: api.UPDATE_CARD, delete: api.DELETE_CARD,
});

export const contentListService = createService({
  getList: api.GET_LIST_CONTENT_LISTS, create: api.CREATE_CONTENT_LIST,
  update: api.UPDATE_CONTENT_LIST, delete: api.DELETE_CONTENT_LIST,
});
// Tra cứu đối tượng cho form Danh sách (theo item_type)
export const searchListObjects = async ({ search, item_type }) => {
  const { data } = await request({ url: api.LIST_SEARCH_OBJECTS, method: 'POST', data: { search, item_type } });
  return data?.data || [];
};
export const resolveListObjects = async ({ ids, item_type }) => {
  const { data } = await request({ url: api.LIST_RESOLVE_OBJECTS, method: 'POST', data: { ids, item_type } });
  return data?.data || [];
};
